'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/stage4/index.js';
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _propTypes = require('@marmalade/prop-types');
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _constants = require('../constants');
var _quote = require('./components/quote');
var _quote2 = _interopRequireDefault(_quote);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
NewStage4.propTypes = {
  linkPrefix: _propTypes2.string.isRequired,
  history: _propTypes.history.isRequired,
  stage3Complete: _propTypes2.bool.isRequired,
  container: _propTypes2.bool.isRequired
};
function NewStage4(props) {
  if (!props.stage3Complete) {
    return _react2.default.createElement(_reactRouterDom.Redirect, {
      to: props.linkPrefix + '/stage1',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      },
      __self: this
    });
  }
  return _react2.default.createElement(_quote2.default, {
    linkPrefix: props.linkPrefix,
    container: props.container,
    history: props.history,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  });
}
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    stage3Complete: (0, _formInfo.isValidAndPristine)(state, _constants.stages[2].formId)
  };
})(NewStage4));